





















import Vue from 'vue'
import { RadioButton, RadioGroup } from 'element-ui'
import { PreviewVideoQualityType, ChromaKeyPreviewQualityType } from '@/types/users'
import './PreviewVideoQualityToggle.scss'

export default Vue.extend({
  name: 'PreviewVideoQualityToggle',
  props: {
    autoupdate: {
      type: Boolean,
      required: true,
      default: false
    },
    previewVideoQuality: {
      type: String as () => PreviewVideoQualityType | undefined
    },
    chromaKeyPreviewQuality: {
      type: String as () => ChromaKeyPreviewQualityType | undefined
    }
  },
  data () {
    return {
      previewVideoQualityValue: PreviewVideoQualityType.High as PreviewVideoQualityType,
      possiblePreviewVideoQualityValues: PreviewVideoQualityType,
      chromaKeyPreviewQualityValue: ChromaKeyPreviewQualityType.Low as ChromaKeyPreviewQualityType,
      possibleChromaKeyPreviewQualityValues: ChromaKeyPreviewQualityType
    }
  },
  created () {
    if (this.previewVideoQuality !== undefined) {
      this.previewVideoQualityValue = this.previewVideoQuality
    }
    if (this.chromaKeyPreviewQuality !== undefined) {
      this.chromaKeyPreviewQualityValue = this.chromaKeyPreviewQuality
    }
  },
  watch: {
    previewVideoQualityValue () {
      this.emitValues()
    },
    chromaKeyPreviewQualityValue () {
      this.emitValues()
    }
  },
  methods: {
    emitValues () {
      this.$emit('ontoggle', {
        previewVideoQualityValue: this.previewVideoQualityValue,
        chromaKeyPreviewQualityValue: this.chromaKeyPreviewQualityValue
      })
    }
  },
  components: {
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup
  }
})
